export const HomeIcon = () => (
    <svg
        width="24"
        height="22"
        viewBox="0 0 24 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M3 24.5H7.5V15.5H16.5V24.5H21V11L12 4.25L3 11V24.5ZM0 27.5V9.5L12 0.5L24 9.5V27.5H13.5V18.5H10.5V27.5H0Z"
            fill="white"
        />
    </svg>
);